// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //Live................

  baseURL: 'https://newapi.silverzone.org/api',

  //Local..............

  // baseURL: 'https://localhost:44320/api',

  pdfBaseUrl: 'https://erpapi.silverzone.org/eBook/',
  BaseURLForImage: 'https://newapi.silverzone.org/',
  notificationTitle: 'Notification',
  Success: 'success',
  BaseURLForQuestion: 'https://question.silverzone.org/',
  // SZF_Key: "rzp_test_nswrXe4pV4k3Ek",
  // SZF_Secret: "EVd7icAv6am2BEytNmbZZdKo"

  SZF_Key: "rzp_live_Eclym59iZHBQ5x",
  SZF_Secret: "0VE5lbcWxPkjD1BMDFLzfszk"
};



